const isInInterval = (containerWidth, device) => {
  if (
    containerWidth !== null &&
    containerWidth !== undefined &&
    device.width[0] <= containerWidth &&
    containerWidth <= device.width[1]
  ) {
    return true;
  }
  return false;
};

const isValidDeviceSetting = (device) => {
  return device !== undefined && device.width !== undefined && device.width.length === 2;
};

const transformLabel = (label) => {
  let array = label.trim().split(' ');
  if (array.length > 1) {
    array = [
      ...array.map((element) => {
        if (element === '&') {
          return 'and';
        }
        return element;
      })
    ];
    return array.join('-');
  } else {
    return label;
  }
};

function createHTMLElementFromString(htmlString) {
  var div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  return div.firstChild;
}

export { isInInterval, isValidDeviceSetting, transformLabel, createHTMLElementFromString };
